import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { mainMenu, MenuItem } from '@/constants/menus';
import { permissions } from '@/constants/routes';
import ModalMenu from '@/components/Header/ModalMenu.vue';
import ModalMenuItem from '@/components/Header/ModalMenuItem.vue';
import IconArrow from '@/components/icons/CarouselLeft.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Mobile',
  setup(__props) {

const store = useStore();
const route = useRoute();
const { t } = useI18n();

const userRole = computed<string>(() => store.getters.role);

const isShow = ref<boolean>(false);

const menu = computed<Array<MenuItem>>(
  () => mainMenu.filter(
    (menuLink) => menuLink.permissions.includes(userRole.value)
        && menuLink.permissions !== permissions.administration.root
  )
);

const handleToggle = (): void => {
  isShow.value = !isShow.value;
};

const handleClose = (): void => {
  isShow.value = false;
};

const firstLevelMenuTitle = computed(() => {
  const routeMatchedNames = route.matched.map(
    (matchedRoute) => matchedRoute.name
  );

  const currentMenuItem = menu.value.find((menuItem) => {
    if (typeof menuItem.link === 'string' || !('name' in menuItem.link)) {
      return false;
    }

    return routeMatchedNames.includes(menuItem.link.name);
  });

  return currentMenuItem?.title || 'portal';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalMenu, {
    class: _normalizeClass(["nav-mobile", { isShow: isShow.value }]),
    isShow: isShow.value,
    onClose: handleClose
  }, {
    button: _withCtx(({ buttonClass }) => [
      _createElementVNode("button", {
        class: _normalizeClass(["nav-mobile__toggle-btn", buttonClass]),
        onClick: handleToggle
      }, [
        _createTextVNode(_toDisplayString(_unref(t)(firstLevelMenuTitle.value)) + " ", 1),
        _createVNode(IconArrow, { class: "nav-mobile__toggle-icon" })
      ], 2)
    ]),
    content: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.value, (element, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: `navLink${index}`
        }, [
          (element.title !== firstLevelMenuTitle.value)
            ? (_openBlock(), _createBlock(ModalMenuItem, {
                key: 0,
                to: element.link,
                link: element.baseUrlLink,
                onClick: handleClose
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(element.title)), 1)
                ]),
                _: 2
              }, 1032, ["to", "link"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _: 1
  }, 8, ["class", "isShow"]))
}
}

})